import styled from 'styled-components';

const StyledPath = styled.path`
    fill: ${({ theme }) => theme.colors['Level 3']};
`;

export default StyledPath;
